import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../api/client';
import { payCommitment } from '../checkout';

const LABEL = { pending_payment: 'Awaiting payment', paid: 'Paid', docs_signed: 'Documents signed', allotted: 'Allotted', refunded: 'Refunded', cancelled: 'Cancelled' };

const MyCommitments = () => {
  const [rows, setRows] = useState(null);
  const load = useCallback(() => api.get('/api/commitments/my/').then((r) => setRows(r.data)).catch(() => toast.error('Failed to load commitments')), []);
  useEffect(() => { load(); }, [load]);

  const pay = async (c) => {
    try {
      const out = await payCommitment(c.id);
      if (out === 'paid') toast.success('Payment received');
    } catch (e) {
      toast.error(e.message);
    }
    load();
  };
  const cancel = async (c) => {
    try { await api.post(`/api/commitments/${c.id}/cancel/`); } catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
    load();
  };

  if (!rows) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  return (
    <main style={{ maxWidth: 900, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>My commitments</h1>
      {rows.length === 0 ? <p>No commitments yet. <Link to="/deals">Browse deals</Link></p> : (
        <table style={{ width: '100%' }}>
          <thead><tr><th align="left">Deal</th><th align="right">Shares</th><th align="right">Amount</th><th align="left">Status</th><th /></tr></thead>
          <tbody>{rows.map((c) => (
            <tr key={c.id}>
              <td><Link to={`/deals/${c.spv}`}>{c.spv_name}</Link></td>
              <td align="right">{c.shares}</td>
              <td align="right">₹{Number(c.amount).toLocaleString('en-IN')}</td>
              <td>{LABEL[c.status]}{c.refund_utr && ` — refund UTR ${c.refund_utr}`}
                {c.status === 'pending_payment' && c.expires_at && <small> (pay before {new Date(c.expires_at).toLocaleTimeString('en-IN')})</small>}</td>
              <td>{c.status === 'pending_payment' && <><button onClick={() => pay(c)}>Pay now</button>{' '}<button onClick={() => cancel(c)}>Cancel</button></>}</td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </main>
  );
};

export default MyCommitments;
